import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useHistory, useParams } from 'react-router'
import CommonPageWrapper from '../../../common/components/CommonPageWrapper'
import Loader from '../../../common/loader/Loader'
import { Query } from '../../../react-apollo/Components'
import { i18n } from '../../index'
import { fetchExpressCheckoutNewPeriodPage } from '../expressCheckoutQueries'
import GoBackButton from '../GoBackButton'
import { Category, OpeningHoursPeriod, RestaurantMenu } from '../types'
import { DEFAULT_OPENING_HOURS_FOR_EXPRESS_CHECKOUT } from '../util'
import { OpeningHoursPeriodForm } from './OpeningHoursPeriodForm'

export default function NewCategoryPeriodPage() {
  const { stationId, categoryId } = useParams<{ stationId: string; categoryId: string }>()
  const history = useHistory()
  return (
    <CommonPageWrapper title={i18n.t('restaurantMenu.categoryPeriods.newCategoryPeriod')}>
      <GoBackButton stationId={stationId} to={`/pikakassa/${stationId}/aukioloajat/${categoryId}`} />
      <Query<
        { expressCheckoutMenu: RestaurantMenu; expressCheckoutCategoryPeriods: OpeningHoursPeriod[] },
        { stationId: string }
      >
        query={fetchExpressCheckoutNewPeriodPage}
        variables={{ stationId: decodeURIComponent(stationId || '') }}
      >
        {({ data, loading }) => {
          const categories = data?.expressCheckoutMenu?.categories ?? []
          const category = categories.find((category: Category) => category.id === categoryId)
          const defaultOpeningHours = category?.defaultOpeningHours ?? DEFAULT_OPENING_HOURS_FOR_EXPRESS_CHECKOUT
          const existingPeriods = data?.expressCheckoutCategoryPeriods.filter((p) => p.categoryId === categoryId) || []
          return (
            <Loader loading={loading}>
              <Stack>
                <Typography variant='h6' gutterBottom>
                  {`${i18n.t('restaurantMenu.categoryPeriods.newCategoryPeriod')} - ${category?.name}`}
                </Typography>
                {category && (
                  <OpeningHoursPeriodForm
                    defaultOpeningHours={defaultOpeningHours || {}}
                    category={category}
                    onCompleted={() => history.push(`/pikakassa/${stationId}/aukioloajat/${categoryId}`)}
                    stationId={stationId}
                    existingPeriods={existingPeriods}
                  />
                )}
              </Stack>
            </Loader>
          )
        }}
      </Query>
    </CommonPageWrapper>
  )
}
